/* global axios */
import ApiClient from './ApiClient';

// Read-only ticket-scoped signature-request listing for the dashboard panel.
// Owner id is the ticket display_id (the URL identifier for nested ticket routes).
class TicketSignatureRequestsAPI extends ApiClient {
  constructor() {
    super('signature_requests', { accountScoped: true });
    this.ownerId = null;
  }

  get url() {
    return `${this.baseUrl()}/tickets/${this.ownerId}/signature_requests`;
  }

  get(ownerId) {
    this.ownerId = ownerId;
    return axios.get(this.url);
  }
}

export default new TicketSignatureRequestsAPI();
